import { jsx as _jsx } from "react/jsx-runtime";
import { IconV2 } from "../../../icon_v2";
// Base styles for consistent arrow styling
const BASE_ARROW_STYLES = {
    background: "white",
    textColor: "black",
    borderColor: "#CDD3DA",
    shadow: "shadow-sm hover:shadow-md",
};
/**
 * A collection of custom arrow components for the CardSlider
 */
export const CircleArrow = ({ type, onClick, disabled, className = "", }) => {
    const Icon = type === "prev" ? (_jsx(IconV2, { type: "fa", icon: {
            icon: "circle-arrow-left",
            fixedWidth: true,
        } })) : (_jsx(IconV2, { type: "fa", icon: {
            icon: "circle-arrow-right",
            fixedWidth: true,
        } }));
    return (_jsx("button", { className: `flex h-12 w-12 items-center justify-center rounded-full border border-[#CDD3DA] bg-white text-gray-800 ${BASE_ARROW_STYLES.shadow} transition-all ${disabled
            ? "cursor-not-allowed opacity-40"
            : "hover:scale-105 hover:bg-gray-50"} ${className}`, onClick: onClick, disabled: disabled, "aria-label": type === "prev" ? "Previous slide" : "Next slide", children: Icon }));
};
export const SquareArrow = ({ type, onClick, disabled, className = "", }) => {
    // const Icon = type === "prev" ? ArrowLeft : ArrowRight;
    const Icon = type === "prev" ? (_jsx(IconV2, { type: "fa", icon: {
            icon: "square-arrow-left",
            fixedWidth: true,
        } })) : (_jsx(IconV2, { type: "fa", icon: {
            icon: "square-arrow-right",
            fixedWidth: true,
        } }));
    return (_jsx("button", { className: `flex h-10 w-10 items-center justify-center rounded-md border border-[#CDD3DA] bg-white text-gray-800 ${BASE_ARROW_STYLES.shadow} transition-all ${disabled
            ? "cursor-not-allowed opacity-40"
            : "hover:border-gray-400 hover:bg-gray-50"} ${className}`, onClick: onClick, disabled: disabled, "aria-label": type === "prev" ? "Previous slide" : "Next slide", children: Icon }));
};
export const TextArrow = ({ type, onClick, disabled, className = "", }) => {
    return (_jsx("button", { className: `rounded-md border border-[#CDD3DA] bg-white px-4 py-2 text-gray-800 ${BASE_ARROW_STYLES.shadow} text-sm font-medium transition-all ${disabled
            ? "cursor-not-allowed opacity-40"
            : "hover:border-gray-400 hover:bg-gray-50"} ${className}`, onClick: onClick, disabled: disabled, "aria-label": type === "prev" ? "Previous slide" : "Next slide", children: type === "prev" ? "Previous" : "Next" }));
};
export const DoubleArrow = ({ type, onClick, disabled, className = "", }) => {
    // const Icon = type === "prev" ? ChevronsLeft : ChevronsRight;
    const Icon = type === "prev" ? (_jsx(IconV2, { type: "fa", icon: {
            icon: "angles-left",
            fixedWidth: true,
        } })) : (_jsx(IconV2, { type: "fa", icon: {
            icon: "angles-right",
            fixedWidth: true,
        } }));
    return (_jsx("button", { className: `flex h-12 w-12 items-center justify-center rounded-full border border-[#CDD3DA] bg-white text-gray-800 ${BASE_ARROW_STYLES.shadow} transition-all ${disabled
            ? "cursor-not-allowed opacity-40"
            : "hover:scale-105 hover:bg-gray-50"} ${className}`, onClick: onClick, disabled: disabled, "aria-label": type === "prev" ? "Previous slide" : "Next slide", children: Icon }));
};
export const MinimalArrow = ({ type, onClick, disabled, className = "", }) => {
    // const Icon = type === "prev" ? ArrowLeft : ArrowRight;
    const Icon = type === "prev" ? (_jsx(IconV2, { type: "fa", icon: {
            icon: "chevron-left",
            fixedWidth: true,
        } })) : (_jsx(IconV2, { type: "fa", icon: {
            icon: "chevron-right",
            fixedWidth: true,
        } }));
    return (_jsx("button", { className: `flex h-8 w-8 items-center justify-center rounded-full border border-[#CDD3DA] bg-white text-gray-800 ${BASE_ARROW_STYLES.shadow} transition-all ${disabled
            ? "cursor-not-allowed opacity-30"
            : "hover:scale-105 hover:bg-gray-50"} ${className}`, onClick: onClick, disabled: disabled, "aria-label": type === "prev" ? "Previous slide" : "Next slide", children: Icon }));
};
